// extracted by css-extract-rspack-plugin
export default {"cls1":"DownloadOptionCard-cls1_mE8","cls2":"DownloadOptionCard-cls2_bTM DownloadOptionCard-cls1_mE8"};